<div
  [attr.data-design-system]="
    contentFooter.darkSiteBlackTheme ? 'delta-mach-1-dark' : ''
  "
  class="flex flex-col h-auto items-center desktop:px-[144px] laptop:px-[72px] tablet:px-[60px] px-[32px] w-full"
  [ngClass]="{
    'bg-[#000000]':
      !disableBackgroundColor &&
      (contentFooter.businessUser || contentFooter.darkSiteBlackTheme),
    ' bg-[linear-gradient(180deg,#001932_0%,#001122_100%)]':
      !disableBackgroundColor &&
      !contentFooter.businessUser &&
      !contentFooter.darkSiteBlackTheme,
    grayscale: contentFooter.darkSiteBlackTheme
  }"
>
  <div class="w-full h-auto" id="mach-homepage-footer" *ngIf="!isLightFooter">
    <div
      class="text-center relative"
      *ngIf="contentFooter.search.placeHolder && displaySearch && !trimFooter"
    >
      <div
        class="flex items-center w-full max-w-md h-16 tablet:mt-[132px] tablet:mb-[48px] mt-72 mx-auto gap-16"
      >
        <div class="relative w-full">
          <input
            class="single-line-input peer"
            type="text"
            [(ngModel)]="searchTerm"
            (keydown.enter)="submitSearch()"
            (focus)="onSearchInputFocus($event)"
            data-acdl-action="footer:search for a topic"
            data-acdl-name="search for a topic"
            data-acdl-page-section="footer:search for a topic"
            id="mach-homepage-footer-search-input"
            name="mach-homepage-footer-search-input"
            placeholder=" "
          />
          <label for="mach-homepage-footer-search-input" class="floating-title">
            {{ contentFooter.search?.placeHolder || '' }}
          </label>
          <button
            *ngIf="searchTerm.length > 0"
            class="absolute right-12 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center !cursor-pointer"
            type="button"
            (click)="onClearSearch()"
            aria-label="Clear search"
            id="mach-homepage-footer-search-clear-button"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 4L4 12M4 4L12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </button>
        </div>
        <button
          #searchButton
          id="homepage-footer-search-button"
          data-acdl-action="footer:search console search"
          data-acdl-name="search for a topic:console search"
          data-acdl-page-section="footer:search for a topic"
          data-search-type="footer:search for a topic"
          (click)="submitSearch($event)"
          class="header-search__icon text-icon-inverse w-8 h-8"
          [attr.aria-label]="contentFooter.search.accessibleTextMsg"
          [style.-webkit-tap-highlight-color]="'transparent'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 33"
            fill="none"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M4.50781 14.0317C4.50781 9.33324 8.33133 5.50991 13.03 5.50991C17.7287 5.50991 21.5522 9.33324 21.5522 14.0317C21.5522 18.7302 17.7287 22.552 13.03 22.552C8.33133 22.552 4.50781 18.7302 4.50781 14.0317ZM29.5 29.0783L21.1499 20.7301C22.6564 18.9081 23.5617 16.5739 23.5617 14.0317C23.5617 8.22428 18.8372 3.5 13.0308 3.5C7.22453 3.5 2.5 8.22428 2.5 14.0317C2.5 19.8377 7.22453 24.562 13.0308 24.562C15.5732 24.562 17.9075 23.6553 19.7296 22.1504L28.0796 30.5L29.5 29.0783Z"
              fill="white"
            />
            <path
              d="M29.5 29.0783L29.6769 29.255L29.8535 29.0782L29.6768 28.9015L29.5 29.0783ZM21.1499 20.7301L20.9573 20.5708L20.8123 20.7461L20.9732 20.9069L21.1499 20.7301ZM19.7296 22.1504L19.9063 21.9736L19.7456 21.8129L19.5704 21.9576L19.7296 22.1504ZM28.0796 30.5L27.9029 30.6768L28.0797 30.8536L28.2565 30.6767L28.0796 30.5ZM4.50781 14.0317H4.75781C4.75781 9.47132 8.46939 5.75991 13.03 5.75991V5.50991V5.25991C8.19327 5.25991 4.25781 9.19515 4.25781 14.0317H4.50781ZM13.03 5.50991V5.75991C17.5907 5.75991 21.3022 9.47132 21.3022 14.0317H21.5522H21.8022C21.8022 9.19515 17.8668 5.25991 13.03 5.25991V5.50991ZM21.5522 14.0317H21.3022C21.3022 18.592 17.5907 22.302 13.03 22.302V22.552V22.802C17.8667 22.802 21.8022 18.8683 21.8022 14.0317H21.5522ZM13.03 22.552V22.302C8.46934 22.302 4.75781 18.592 4.75781 14.0317H4.50781H4.25781C4.25781 18.8683 8.19333 22.802 13.03 22.802V22.552ZM29.5 29.0783L29.6768 28.9015L21.3267 20.5533L21.1499 20.7301L20.9732 20.9069L29.3232 29.2551L29.5 29.0783ZM21.1499 20.7301L21.3426 20.8894C22.8846 19.0244 23.8117 16.6343 23.8117 14.0317H23.5617H23.3117C23.3117 16.5135 22.4281 18.7918 20.9573 20.5708L21.1499 20.7301ZM23.5617 14.0317H23.8117C23.8117 8.08622 18.9752 3.25 13.0308 3.25V3.5V3.75C18.6991 3.75 23.3117 8.36234 23.3117 14.0317H23.5617ZM13.0308 3.5V3.25C7.08645 3.25 2.25 8.08622 2.25 14.0317H2.5H2.75C2.75 8.36234 7.36261 3.75 13.0308 3.75V3.5ZM2.5 14.0317H2.25C2.25 19.9758 7.08647 24.812 13.0308 24.812V24.562V24.312C7.36259 24.312 2.75 19.6996 2.75 14.0317H2.5ZM13.0308 24.562V24.812C15.6337 24.812 18.0238 23.8835 19.8888 22.3431L19.7296 22.1504L19.5704 21.9576C17.7912 23.4271 15.5127 24.312 13.0308 24.312V24.562ZM19.7296 22.1504L19.5528 22.3272L27.9029 30.6768L28.0796 30.5L28.2564 30.3232L19.9063 21.9736L19.7296 22.1504ZM28.0796 30.5L28.2565 30.6767L29.6769 29.255L29.5 29.0783L29.3231 28.9016L27.9028 30.3233L28.0796 30.5Z"
              fill="white"
            />
          </svg>
        </button>
      </div>

      <div class="hidden tablet:block" *ngIf="contentFooter.populartopics">
        <div
          id="mach-homepage-footer-popular-topics"
          class="flex justify-center items-baseline gap-32"
        >
          <h3 class="text-label-md-semibold text-navigation">
            {{ contentFooter.populartopics.heading }}
          </h3>
          <ul class="flex list-none pl-0 gap-24">
            <li
              *ngFor="
                let topic of contentFooter.populartopics.popularTopicsList;
                let i = index
              "
            >
              <a
                class="text-label-md-semibold text-inverse hover:underline"
                [attr.href]="topic?.itemUrl || '#'"
                [attr.target]="topic?.newwindow === 'true' ? '_blank' : ''"
                [attr.data-acdl-page-section]="
                  'footer:' +
                  (contentFooter.populartopics.heading | lowercase).replace(
                    ':',
                    ''
                  )
                "
                [attr.data-acdl-name]="topic?.itemtext || ''"
                [attr.data-acdl-action]="
                  'footer:' + (contentFooter.populartopics.heading | lowercase)
                "
                (click)="setTrackingEvents($event); (true)"
              >
                {{ topic?.itemtext || '' }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <hr
      [ngClass]="{
        'border-[#3a4351]':
          contentFooter.businessUser || contentFooter.darkSiteBlackTheme,
        'border-stroke-04':
          !contentFooter.businessUser && !contentFooter.darkSiteBlackTheme,
        '!mt-0': !displaySearch
      }"
      class="h-px laptop:mt-48 laptop:mb-48 tablet:mt-40 tablet:mb-40 mt-20 mb-20 border border-stroke-04"
      *ngIf="!trimFooter"
    />

    <div *ngIf="!trimFooter" class="w-full">
      <idp-footer-column
        [isBusiness]="contentFooter.businessUser"
        [content]="contentFooter.footercolumns"
        [darkSiteTheme]="contentFooter.darkSiteBlackTheme"
        (analyticsEvent)="searchInputAnalyticsEvent.emit($event)"
      ></idp-footer-column>
    </div>

    <div
      class="text-center tablet:mt-[48px] mt-[36px] w-full max-w-7xl mx-auto"
    >
      <idp-information [contentInfo]="contentFooter.info"></idp-information>
    </div>

    <div
      class="relative flex tablet:flex-row flex-col items-center justify-center p-0 opacity-100 mt-40 tablet:mb-72 mb-32"
      [ngClass]="{
        'mt-40':
          contentFooter &&
          (!contentFooter.feedback ||
            !contentFooter.social ||
            !contentFooter.countryLanguage.country)
      }"
    >
      <div *ngIf="contentFooter?.social">
        <idp-social-icons
          [iconsContent]="contentFooter.social"
          (iconClick)="iconClicked($event)"
          (analyticsEvent)="analyticsEvent.emit($event)"
        ></idp-social-icons>
      </div>

      <div
        *ngIf="contentFooter?.countryLanguage?.country"
        [ngClass]="{
          'pointer-events-none opacity-05': disableLangSelection
        }"
        class="flex-none order-1 flex flex-col justify-center items-center p-0 gap-10 w-auto tablet:mt-0 mt-40"
      >
        <idp-lang-selector-wrapper></idp-lang-selector-wrapper>
      </div>
    </div>

    <hr
      class="border border-stroke-04 mb-48"
      *ngIf="contentFooter.additionalInfo"
    />
    <div class="text-center mb-48" *ngIf="contentFooter.additionalInfo">
      <p
        class="text-body-xs text-navigation"
        [innerHTML]="contentFooter.additionalInfo"
      ></p>
    </div>
  </div>

  <div class="py-8 flex justify-center outline-none" *ngIf="isLightFooter">
    <div class="text-center">
      <p class="text-body-xs text-navigation">
        {{ contentFooter.info.copyright }}
      </p>
    </div>
  </div>
</div>
